import React from 'react'
import isEmail from 'validator/lib/isEmail'
import isEmpty from 'validator/lib/isEmpty'
import isPostalCode from 'validator/lib/isPostalCode'

export const isRequired = (value) => {
  if (isEmpty(value.toString().trim())) {
    return <span>Diese Feld muss ausgefüllt werden.</span>
  }
  return false
}

export const validEmail = (value) => {
  if (!isEmail(value)) {
    return <span>{value} ist keine gültige Email-Adresse.</span>
  }
  return false
}

export const validPostal = (value) => {
  if (!isPostalCode(value, 'CH')) {
    return <span>{value} ist keine gültige Postleitzahl.</span>
  }
  return false
}

export const validPhone = (value) => {
  if (value.toString().trim().length !== 16) {
    return <span>{value} ist keine gültige Telefon-Nummer.</span>
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/validations.jsx